import React from 'react';
import { API_DOCS } from '../consts/apiDocs.const';

/**
 * Компонент с текстом соглашения для формы оформления заказа
 */
export const TermsAgreement: React.FC = () => {
  return (
    <div className="mt-3 px-4 text-center text-xs text-text-muted">
      Нажимая «Перейти к оплате», вы соглашаетесь с{' '}
      <a
        href={API_DOCS.AGREEMENT}
        target="_blank"
        rel="noopener noreferrer"
        className="text-text-link hover:text-text-link-hover hover:underline"
      >
        пользовательским соглашением
      </a>
      ,{' '}
      <a
        href={API_DOCS.OFFER}
        target="_blank"
        rel="noopener noreferrer"
        className="text-text-link hover:text-text-link-hover hover:underline"
      >
        офертой
      </a>{' '}
      и{' '}
      <a
        href={API_DOCS.POLITIC}
        target="_blank"
        rel="noopener noreferrer"
        className="text-text-link hover:text-text-link-hover hover:underline"
      >
        политикой конфиденциальности
      </a>
    </div>
  );
};
